export default {
  contrapartidas: [],
  contrapartida: {},
  pagination: {
    current_page: 1,
    per_page: 15,
  },
};
